import React, { useState, useEffect } from "react";
import { GridViewContext, GridViewRowContext } from '../Contexts';
import useDebounce from "../Hooks/useDebounce";
import { useLocalStorage } from "../Hooks";

const GridViewProvider = () => {};

GridViewProvider.Main = (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [innerWhere, setInnerWhere] = useState(props.where);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const debouncedWhere = useDebounce(innerWhere, 500);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [storedWhere, setStoredWhere] = useLocalStorage(props.whereKey, {});

// eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (props.whereKey && storedWhere !== null) {
      setInnerWhere({ ...storedWhere, isDone: true });
    } else {
      setInnerWhere({ ...innerWhere, isDone: true });
    }
  }, []);
// eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (props.whereKey) {
      setStoredWhere(innerWhere);
    }
    if (props.setWhere) {
      props.setWhere(innerWhere);
    }
    if (innerWhere?.CantidadPorPagina) {
      props.setPagination({
        ...props.pagination,
        CantidadPorPagina: innerWhere.CantidadPorPagina ?? 15,
      });
    }
  }, [debouncedWhere]);

  const state = {
    allowPaging: props.allowPaging ?? true,
    allowSorting: props.allowSorting ?? true,
    dataSource: props.dataSource ?? [],
    primaryKey: props.primaryKey ?? "IdSec",
    pageSize: props.pageSize ?? 10,
    columns: (props.columns ?? []).filter((c) => c && c.props),
    currentPage: (props.pageIndex ?? 0) + 1,
    lastPageNumber: props.lastPageNumber ?? 1,
    where: innerWhere,
    setWhere: setInnerWhere,
    pagination: props.pagination,
    setPagination: props.setPagination,
    hideFilters: props.hideFilters,
    height: props.height,
    onReset: props.onReset,
    showPagination: props.showPagination != null ? props.showPagination : true,
  };

  const dispatch = (action) => {
    switch (action.type) {
      case "previous":
        if (state.currentPage > 1) {
          props.onPageIndexChanging(state.currentPage - 1);
        }
        break;
      case "next":
        if (state.currentPage < state.lastPageNumber) {
          props.onPageIndexChanging(state.currentPage + 1);
        }

        break;
    }
  };

  const value = {
    state,
    dispatch,
  };

  return (
    <GridViewContext.Provider value={value}>
      {props.children}
    </GridViewContext.Provider>
  );
};

GridViewProvider.Row = (props) => {
  const state = {
    row: props.row,
  };

  const dispatch = (action) => {
    switch (action.type) {
      case "update":
        break;
    }
  };

  return (
    <GridViewRowContext.Provider value={{ state, dispatch }}>
      {props.children}
    </GridViewRowContext.Provider>
  );
};
export { GridViewProvider };
